// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import {
  setApplicationsListSelectRedux,
  setCustomerRedux,
  setCustomersRedux,
} from './customerSlice';
import { hideIconRequestErrors, showIconRequestErrors } from '../errors';
import {
  deleteCustomerService,
  addApplicationToCustomerService,
  restoreCustomerService,
  getAllCustomerService,
  getAllCustomerByParamService,
  getAllCustomerNoPaginateService,
  getApplicationCustomerService,
  getApplicationsPermissionsCustomerService,
  getDetailCustomerService,
  removeApplicationCustomerService,
  setCustomerService,
  updateCustomerService,
  updatePermissionsCustomerService,
} from '../../services';
import { QueryPagination } from '../../commons/interfaces';
import { setPermissionsTree } from '../permissions';

export const getApplicationCustomerStore = (): any => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());

    await dispatch(checkingPreload());

    const result = await getApplicationCustomerService();

    if (result.ok) {
      await dispatch(setApplicationsListSelectRedux(result.data));
    }

    await dispatch(unCheckingPreload());

    return result;
  };
};

export const saveCustomer = (customer: any, setPercentajeCCompany: any): any => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());

    const result = await setCustomerService(customer, setPercentajeCCompany);

    // await dispatch( hideIconRequestErrors() );

    // ( result.ok ) ? dispatch( hideIconRequestErrors() )  : dispatch( showIconRequestErrors() );

    dispatch(unCheckingPreload());

    return result;
  };
};

export const addApplicationToCustomer = (application: any, setPercentajeCCompany: any): any => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());

    const dataSave = {
      applicationId: application.applicationId.value,
      customerId: application.customerId,
    };

    const result = await addApplicationToCustomerService(dataSave, setPercentajeCCompany);

    dispatch(unCheckingPreload());

    return result;
  };
};

export const editCustomer = (customer: any, setPercentajeCCompany: any): any => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());

    const result = await updateCustomerService(customer);

    dispatch(unCheckingPreload());

    return result;
  };
};

export const getCustomersStore = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getAllCustomerNoPaginateService();

    if (result.ok) {
      await dispatch(setCustomersRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeGetDetailCustomer = (customerId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    // OBTIENE LOS DATOS PARA DETALLE DE CUSTOMER
    const result = await getDetailCustomerService(customerId);

    if (result.ok) {
      await dispatch(setCustomerRedux(result.data));
      await dispatch(setApplicationsListSelectRedux(result.data.applicationsForSelect));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const getApplicationsPermissionsCustomerStore = (
  idCustomerApplication: string,
  customerId: string
): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    // OBTIENE LOS DATOS PARA EDITAR DE CUSTOMER
    const result = await getApplicationsPermissionsCustomerService(
      idCustomerApplication,
      customerId
    );

    if (result.ok) {
      await dispatch(setPermissionsTree(result.data.permissions));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const updatePermissionsCustomer = (
  customerId: string,
  applicationUpdateId: string,
  modulesUpdate: any[]
): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    // SE VAN A ACTUALIZAR LOS PERMISOS POR APLICAICON DE USUARIO
    // ES DECIR LA FILA DE LA TABLA CON LOS PERMISOS ASOCIADOS A ESA APLCIACION
    const dataUpdate = {
      idCustomer: customerId,
      idApplication: applicationUpdateId,
      permissions: modulesUpdate,
    };

    console.log('chambeaaaaaaaaaaa');
    // OBTIENE LOS DATOS PARA EDITAR DE CUSTOMER
    const result = await updatePermissionsCustomerService(dataUpdate);

    // if ( result.ok ) {
    //     await dispatch( setPermissionsApplicationCustomer(result.data.permissionsApplicationCustomer) );
    //     await dispatch( setPermissionsCustomer(result.data.permissionsCustomer) );
    // }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const getCustomersByParamStore = (param: number): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    await dispatch(hideIconRequestErrors());

    const result = await getAllCustomerByParamService(param);

    if (result.ok) {
      await dispatch(setCustomersRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const getAllCustomerStore = (query: QueryPagination = {}): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      await dispatch(hideIconRequestErrors());

      const result = await getAllCustomerService(query);

      if (result && result.ok) {
        await dispatch(setCustomersRedux(result.data));
      }

      return result;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(unCheckingPreload());
    }
  };
};

export const deleteCustomerStore = (customerId: string, query: QueryPagination = {}): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      await dispatch(hideIconRequestErrors());

      const result = await deleteCustomerService(customerId, query);

      if (result && result.ok) {
        await dispatch(setCustomersRedux(result.data));
      }

      return result;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(unCheckingPreload());
    }
  };
};

export const restoreCustomerStore = (customerId: string, query: QueryPagination = {}): any => {
  return async (dispatch: any) => {
    try {
      await dispatch(checkingPreload());
      await dispatch(hideIconRequestErrors());

      const result = await restoreCustomerService(customerId, query);

      if (result && result.ok) {
        await dispatch(setCustomersRedux(result.data));
      }

      return result;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(unCheckingPreload());
    }
  };
};

export const removeApplicationCustomer = (applicationId: string, customerId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await removeApplicationCustomerService(applicationId, customerId);

    dispatch(unCheckingPreload());

    return result;
  };
};
